import type { ComponentProps } from 'react'
import * as React from 'react'

import CruiseBookmarkButton from './CruiseBookmarkButton'
import HomeAndVillasBookmarkButton from './HomeAndVillasBookmarkButton'
import HotelBookmarkButton from './HotelBookmarkButton'
import TourBookmarkButton from './TourBookmarkButton'

import {
  isCruiseOffer,
  isHotel,
  isTourV2Offer,
  isVillaOffer,
} from 'lib/offer/offerTypes'
import type BaseBookmarkButton from '../Common/BaseBookmarkButton'

type CruiseButtonProps = ComponentProps<typeof CruiseBookmarkButton>
type HomeAndVillasButtonProps = ComponentProps<typeof HomeAndVillasBookmarkButton>
type HotelButtonProps = ComponentProps<typeof HotelBookmarkButton>
type TourButtonProps = ComponentProps<typeof TourBookmarkButton>

export type Props =
  | CruiseButtonProps
  | HotelButtonProps
  | TourButtonProps
  | HomeAndVillasButtonProps
  | {
    offer:
      | App.AnyOffer
      | App.Offer
      | App.OfferSummary
      | App.BedbankOffer
      | App.BedbankOfferSummary
      | App.Tours.TourV2Offer
      | App.Tours.TourV2OfferSummary
    withLabel?: React.ComponentProps<typeof BaseBookmarkButton>['withLabel']
    size?: React.ComponentProps<typeof BaseBookmarkButton>['size']
    iconKind?: React.ComponentProps<typeof BaseBookmarkButton>['iconKind']
    iconVariant?: React.ComponentProps<typeof BaseBookmarkButton>['iconVariant']
  }

function isTourProps(props: Props): props is TourButtonProps {
  return isTourV2Offer(props.offer) || props.offer.type === 'tour'
}

function isCruiseProps(props: Props): props is CruiseButtonProps {
  return isCruiseOffer(props.offer)
}

function isHotelProps(props: Props): props is HotelButtonProps {
  return isHotel(props.offer)
}

function isHomeAndVillaProps(props: Props): props is HomeAndVillasButtonProps {
  return isVillaOffer(props.offer)
}

/**
 * @param props
 * @constructor
 */
function BookmarkButton(props: Props) {
  if (isTourProps(props)) {
    return <TourBookmarkButton {...props} />
  }

  if (isCruiseProps(props)) {
    return <CruiseBookmarkButton {...props} />
  }

  if (isHomeAndVillaProps(props)) {
    return <HomeAndVillasBookmarkButton {...props} />
  }

  if (isHotelProps(props)) {
    return <HotelBookmarkButton {...props} />
  }

  return null // Shouldn't get here - for type checking only
}

export default React.memo(BookmarkButton)
